/* eslint-disable max-classes-per-file */
import { IHaccpCreate, IHaccpPerformRequest, IHaccpPostpone } from '../models/haccp.model';

export class LoadHaccpLog {
  static readonly type = '[Haccp] Load Haccp log by id';
  constructor(
    public haccpId: string,
    public startDate?: Date,
    public endDate?: Date,
    public showAllColumns?: boolean,
    public sortByPerformedAscending?: boolean
  ) {}
}

export class LoadHaccpVersion {
  static readonly type = '[Haccp] Load Haccp version by id';
  constructor(
    public haccpId: string,
    public haccpVersionId: string
  ) {}
}

export class CreateHaccp {
  static readonly type = '[Haccp] Create Haccp';
  constructor(public haccp: IHaccpCreate) {}
}

export class UpdateHaccp {
  static readonly type = '[Haccp] Update Haccp';
  constructor(public haccp: IHaccpCreate) {}
}

export class DeleteHaccp {
  static readonly type = '[Haccp] Delete Haccp';
  constructor(public haccpId: string) {}
}

export class PostponeHaccp {
  static readonly type = '[Haccp] Postpone Haccp';
  constructor(public haccpPostpone: IHaccpPostpone) {}
}

export class PerformHaccp {
  static readonly type = '[Haccp] Perform Haccp';
  constructor(public haccp: IHaccpPerformRequest) {}
}

export class UpdateHaccpPerform {
  static readonly type = '[Haccp] Update Haccp Perform';
  constructor(
    public haccp: IHaccpPerformRequest,
    public versionId: string
  ) {}
}

export class RestoreHaccp {
  static readonly type = '[Haccp] Restore Haccp';
  constructor(public id: string) {}
}

export class LoadHaccpDraftPerform {
  static readonly type = '[Haccp] Load Haccp Draft Perform';
  constructor(public haccpId: string) {}
}

export class LoadHaccpPerform {
  static readonly type = '[Haccp] Load Haccp Perform';
  constructor(
    public haccpId: string,
    public haccpVersionId: string
  ) {}
}

export class SaveHaccpDraftPerform {
  static readonly type = '[Haccp] Save Haccp Draft Perform';
  constructor(public haccp: IHaccpPerformRequest) {}
}

export class PrintExcel {
  static readonly type = '[Haccp] Print excel';
  constructor(
    public id: string,
    public from?: Date,
    public to?: Date,
    public showAllColumns?: boolean
  ) {}
}
